export default __webpack_public_path__ + "static/media/male2.99503b69.png";